import { render, staticRenderFns } from "./InstanceManagement.vue?vue&type=template&id=1d6e0166"
import script from "./InstanceManagement.vue?vue&type=script&lang=js"
export * from "./InstanceManagement.vue?vue&type=script&lang=js"
import style0 from "./InstanceManagement.vue?vue&type=style&index=0&id=1d6e0166&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports